import styled from 'styled-components';
import bg_01 from '../../assets/images/bg_01.png';

export const Wrapper = styled.div`
  height:100vh;display: flex;flex-direction: column;align-items: center;justify-content: center;
  padding-bottom:0;padding-bottom:env(safe-area-inset-bottom);overflow:hidden;
  .btn{
    width:100%;height: 1.2rem;background: #FFFFFF;font-size: .36rem;font-weight: 400;color: #595E89;line-height: 1.2rem;text-align:center;
  }
`;

export const Container = styled.div`
  width:100%;flex: 1;overflow:auto;background:#d7d2e7;padding-bottom:.4rem;
  .bg1{
    width:100%;display:block;position:relative;z-index:1;
  }
  .bg2{
    width:7.2rem;display:block;margin:-.6rem auto 0;position:relative;z-index:2;
  }
  .text{
    div{
      font-size: .34rem;font-weight: 400;color: #595E89;line-height: .3rem;text-align:center;height:.3rem;margin:.3rem auto 0;
    }
    p{
      font-size: .28rem;font-weight: 400;color: #595E89;line-height: .44rem;padding:0 .3rem;margin-top:.3rem;
    }
    span{
      display:block;font-size: .28rem;font-weight: 400;color: #595E89;line-height: .44rem;padding:0 .3rem;margin-top:.3rem;
    }
  }
  .component{
    width: 100%;height: 100%;background: rgba(0,0,0,0);transition: all .25s;position: fixed;top:0;left: 0;z-index: 101;
    display: flex;flex-direction:column;align-items: center;justify-content: center;overflow: hidden;padding:0 .3rem;
    .componentor{
      width:100%;opacity: 1;transition: all .25s;height:auto;border-radius:.1rem;overflow:hidden;
      .bg_01{
        background:url(${bg_01}) no-repeat;height:1.7rem;background-size:100% 100%;padding-right:.34rem;
        display: flex;flex-direction:column;align-items: flex-end;justify-content: center;
        span{
          height:.42rem;line-height:.42rem;font-size: .32rem;font-weight: 400;color: #595E89;display:block;
        }
      }
      .title{
        display: flex;align-items: center;justify-content: center;
        span{
          font-size: .36rem;font-weight: 500;color: #595E89;margin:-.1rem .22rem 0;
        }
        img{
          width:.29rem;height:.42rem;display:block;
        }
      }
      .msg{
        font-size: .28rem;font-weight: 400;color: #595E89;line-height: .42rem;text-align:center;margin-top:.2rem;padding: 0 .5rem;
      }
      .bg_02{
        background:#ffffff;padding:.44rem 0 .34rem;
      }
      .bg_03{
        background:#F5F5F5;padding:.4rem 0;
        .phone{
          display: flex;align-items: center;justify-content: center;margin-top:.22rem;height:.28rem;
          span{
            font-size: .32rem;font-weight: 400;color: #2B84FC;
          }
          b{
            font-size: .28rem;font-weight: 400;color: #2B84FC;margin-left:.52rem;
          }
        }
        .msg{
          margin-top:.48rem;
        }
        .code{
          width:100%;display:block;margin:.2rem auto 0;
        }
      }
    }
    .close{
      width:.7rem;height:.7rem;margin:.6rem auto 0;border-radius:50%;overflow:hidden;transition: all .25s;
      img{
        width:100%;height:100%;display:block;
      }
    }
  }
  .component.show{
    visibility: show;background: rgba(0,0,0,.7);
  }
  .component.hide{
    visibility: hidden;
    .componentor,.close{
      opacity: 0;
    }
  }
`;